import React, {useEffect, Fragment, useRef, useCallback} from 'react'
import Layout from '../core/Layout';
import { useDispatch, useSelector } from 'react-redux'
import "../styles.css";
import { patientsDetailsUser } from '../actions/patientActions'
import { Button } from "antd";
import { useParams , useNavigate , Link} from 'react-router-dom';
import AppointmentDetail from '../component/appointmentDetail';
import { useInfiniteAppointments } from '../component/api/app';

const SCROLL_STORAGE_KEY = "appointmentScrollPosition";

const PatDetails = () => {

    const {id} = useParams()
    const navigate = useNavigate()

    const dispatch = useDispatch()

    const userLogin = useSelector((state) => state.userLogin)
    const { userInfo } = userLogin

    useEffect(() => {
        if (userInfo ) {
            dispatch(patientsDetailsUser(id))
        } else {
            navigate('/signin')
        }
    }, [dispatch, userInfo])

    
     const {
              data,
              fetchNextPage,
              hasNextPage,
              isFetchingNextPage,
              isLoading,
              error,
              refetch,
          } = useInfiniteAppointments({
              limit: 10,
              patient: id
          });
    
          const scrollRef = useRef(null);
              const saveScrollPosition = () => {
                  if (scrollRef.current) {
                      localStorage.setItem(
                          SCROLL_STORAGE_KEY,
                          scrollRef.current.scrollTop
                      );
                  }
              };
          
              const restoreScrollPosition = () => {
                  const savedScrollTop = localStorage.getItem(SCROLL_STORAGE_KEY);
                  if (scrollRef.current && savedScrollTop) {
                      scrollRef.current.scrollTop = parseInt(savedScrollTop, 10);
                  }
              };
          
              useEffect(() => {
                  restoreScrollPosition();
              }, []);
          
              useEffect(() => {
                  const handleBeforeUnload = () => saveScrollPosition();
                  window.addEventListener("beforeunload", handleBeforeUnload);
          
                  return () => {
                      window.removeEventListener("beforeunload", handleBeforeUnload);
                      saveScrollPosition();
                  };
              }, []);

    const patientDetailsUser = useSelector((state) => state.patientDetailsUser)
    const { patient : appointment} = patientDetailsUser   // it is a appointment 

      const handleObserver = useRef();
      
  const lastElement = useCallback(
        (element) => {
            if (isLoading || isFetchingNextPage) return;
            if (handleObserver.current) handleObserver.current.disconnect();

            handleObserver.current = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && hasNextPage) {
                        fetchNextPage();
                    }
                });
            });

            if (element) handleObserver.current.observe(element);
        },
        [isLoading, isFetchingNextPage, hasNextPage, fetchNextPage]
    );

    return (
        <Layout title={`${appointment[0]?.patient.firstName + appointment[0]?.patient.lastName}`}>
             <div className="mt-4 " style={{ display : 'flex' , justifyContent : 'center' , alignItem : 'center'}}>
           
                 <div className="p-4 max-w-md mx-auto bg-white shadow-md rounded-xl" style={{ flex : '1 0 auto'}}>
  <div className="space-y-2">
    <p><strong>Patient Number:</strong> {appointment[0]?.patient?.patientNumber || "N/A"}</p>
    <p><strong>Name:</strong> {appointment[0]?.patient?.firstName} {appointment[0]?.patient?.lastName}</p>
    <p><strong>Gender:</strong> {appointment[0]?.patient?.gender || "N/A"}</p>
    <p><strong>Phone:</strong> {appointment[0]?.patient?.phoneNo || "N/A"}</p>
    <p><strong>Address:</strong> {appointment[0]?.patient?.address || "N/A"}</p>
    <p><strong>Active:</strong> {appointment[0]?.patient?.isActive ? "Yes" : "No"}</p>
    <p><strong>Vital Records:</strong> {appointment[0]?.patient?.vital?.length > 0 ? "Available" : "None"}</p>
    <p><strong>Medical History:</strong> {appointment[0]?.patient?.medicalhistory?.length > 0 ? "Available" : "None"}</p>
  </div>
                 </div>
                 <div style={{ overflow : 'auto'}}>
         
              {data?.pages?.map((group, index) =>
                            group.appointment.map((app, i) => {
                                const isLastItem =
                                    index === data.pages.length - 1 &&
                                    i === group.appointment.length - 1;
                                return (
                                    <AppointmentDetail
                                        lastElement={
                                            isLastItem ? lastElement : null
                                        }
                                        key={app._id}
                                        app={app}
                                    />
                                );
                            })
                        )}

</div>
    </div>
        </Layout>
    )
}




export default PatDetails